<template>
	<div class="ms-talk-message" :class="classDisplayMessage">
		<div class="ms-talk-message-photo" @click="onClickEditAlbum(message)" v-if="thumbnailPresence">
			<div class="from-name"><v-icon style="vertical-align: bottom;">account_circle</v-icon>{{ message.from_name }}</div>
			<div class="title">{{ message.data.title }}</div>
			<div class="message">{{ message.data.message }}</div>
			<div class="thumbnails">
				<div
					v-for="(thumbnail, index) in message.data.thumbnails"
					v-bind:key="index"
					v-bind:style="styleThumbnail(index)"
					v-bind:class="classDisplaySize"
				>
					<div class="thumbnails-overlay" v-bind:style="styleThumbnails(index)"></div>
					<v-lazy-image
						:src="thumbnail"
						class="image"
					/>
				</div>
				<div class="exceed" v-if="exceedThumbnails">+{{ showExceedThumbnails }}</div>
			</div>
			<div class="time">{{ message.insert_at.hour }}:{{ message.insert_at.minute }}</div>
		</div>
		<div class="ms-talk-message-notification" @click="onClickEditAlbum(message)" v-else>
			<div class="time">{{ message.insert_at.hour }}:{{ message.insert_at.minute }}</div>
			<div class="message">{{ message.data.message }}</div>
		</div>
	</div>
</template>
<script>
import VLazyImage from 'v-lazy-image';

const THUMBNAILS_DISPLAY_LIMIT = 4;

export default {
	name: 'MSTalkMessagePhotoAlbum',
	components: {
		VLazyImage,
	},
	props: ["message", "myMemberID"],
	data () {
		return {
		}
	},
	methods: {
		onClickEditAlbum: function(message_info) {
			this.$router.push({
				name: 'MSPhotoAlbum',
				params: {
					'contractor_id': this.$route.params.contractor_id,
					'id': this.$route.params.id,
					'photoalbum_id': message_info.data.photoalbum_id,
				},
			});
		},
		isMyMessage: function() {
			return this.message.from === this.myMemberID;
		},
	},
	computed: {
		thumbnailPresence: function() {
			if (this.message.data.thumbnails.length > 0)
				return true;
			return false;
		},
		exceedThumbnails: function() {
			if (this.message.data.thumbnails.length > THUMBNAILS_DISPLAY_LIMIT)
				return true;
			return false;
		},
		classDisplayMessage: function() {
			if (this.thumbnailPresence) {
				if (this.isMyMessage())
					return ['mine'];
				else
					return ['other'];
			}
			return [];
		},
		styleThumbnails: function() {
			return function(index) {
				let opacity = 0;
				if (this.exceedThumbnails && index == THUMBNAILS_DISPLAY_LIMIT - 1)
					opacity = 0.6;
				return {
					"opacity": opacity,
				};
			};
		},
		styleThumbnail: function() {
			return function(index) {
				if (index > THUMBNAILS_DISPLAY_LIMIT - 1)
					return {"display": 'none'};
				return '';
			};
		},
		showExceedThumbnails: function() {
			if (this.exceedThumbnails)
				return this.message.data.thumbnails.length - THUMBNAILS_DISPLAY_LIMIT;
			return '';
		},
		classDisplaySize: function() {
			if (this.message.data.thumbnails.length === 1)
				return 'one';
			else if (this.message.data.thumbnails.length === 2)
				return 'two';
			else if (this.message.data.thumbnails.length === 3)
				return 'three';
			else
				return 'few';
		},
	},
};
</script>
<style>
.ms-talk-message {
	display: flex;
	justify-content: center;
}
.ms-talk-message-photo {
	position: relative;
	width: 70%;
	max-width: 400px;
	padding: 10px 20px;
	margin: 10px 20px 10px 20px;
	background-color: #87cefa;
	border-radius: 15px;
	cursor: pointer;
}
.ms-talk-message.other .ms-talk-message-photo {
	margin-top: 30px !important;
}
.ms-talk-message.mine {
	justify-content: flex-end;
}
.ms-talk-message.other {
	justify-content: flex-start;
}
.ms-talk-message-notification {
	position: relative;
	margin: 10px 5%;
	padding: 10px 20px;
	background-color: #d3d3d3;
	border-radius: 15px;
	cursor: pointer;
}
.ms-talk-message-notification .time {
	overflow: hidden;
	width: 100%;
	height: 24px;
	margin: 5px 0px;
	text-align: center;
}
.ms-talk-message-notification .message {
	margin: 5px 0px;
}
.ms-talk-message-photo .from-name {
	position: absolute;
	top: -1.8rem;
	font-size: 14px;
}
.ms-talk-message.mine .ms-talk-message-photo .from-name {
	right: 0;
	display: none;
}
.ms-talk-message.other .ms-talk-message-photo .from-name {
	left: .5rem;
}
.ms-talk-message-photo .title {
	overflow: hidden;
	width: 100%;
	height: 1em;
	margin: 5px 0px;
	font-weight: bold;
}
.ms-talk-message-photo .message {
	text-align: left;
	margin: 5px 0px;
}
.ms-talk-message-photo .thumbnails {
	position: relative;
	margin: 5px 0px;
	width: 100%;
	height: 180px;
}
.ms-talk-message-photo .one {
	position: relative;
	display: inline-block;
	width: 100%;
	height: 100%;
}
.ms-talk-message-photo .two {
	position: relative;
	display: inline-block;
	width: 50%;
	height: 100%;
}
.ms-talk-message-photo .three {
	position: absolute;
	width: 50%;
	height: 50%;
}
.ms-talk-message-photo .three:first-child {
	top: 0;
	left: 0;
	height: 100% !important;
}
.ms-talk-message-photo .three:nth-of-type(2) {
	top: 0;
	left: 50%;
}
.ms-talk-message-photo .three:last-child {
	top: 50%;
	left: 50%;
}
.ms-talk-message-photo .few {
	position: relative;
	display: inline-block;
	width: 50%;
	height: 50%;
}
.ms-talk-message-photo .image {
	border: solid 1px #ffffff;
	vertical-align: middle;
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.ms-talk-message-photo .time {
	position: absolute;
	bottom: 0;
	font-size: 10px;
}
.ms-talk-message.mine .ms-talk-message-photo .time {
	left: -30px;
}
.ms-talk-message.other .ms-talk-message-photo .time {
	right: -30px;
}
.ms-talk-message-photo .thumbnails-overlay {
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: #000000;
	z-index: 100;
}
.ms-talk-message-photo .exceed {
	position: absolute;
	bottom: 10%;
	right: 20%;
	color: #ffffff;
	text-weight: bold;
	font-size: 32px;
	z-index: 101;
}
</style>
